const en = {
	accountCenter: {
		myAccount: 'Withdrawal Accounts',
		withdrawalAccounts: 'Total:',
		withdrawalAccountsSub: ',Approved:',
		pending: 'Accounts pending',
		fail: 'Account failed',
		see: 'More',
		safeCenter: 'Security Center',
		password: 'Login password',
		phone: 'Bind phone number',
		email: 'Bind mailbox',
		keySetting: 'Salt setting',
		changePassword: 'Change',
		changePhone: 'Change',
		bindEmail: 'Bind mailbox',
		changeEmail: 'Change',
		saltSetting: 'Salt setting',
		setting: 'Setting',
		passwordDesc: 'The higher the password strength, the higher the security level of the account, not easy to be illegally used',
		phoneDesc: 'Security verification, cash changes in the income account will be sent by the way of SMS verification code',
		emailDesc: 'As your login mailbox, password retrieval and other authentication actions will also be sent to this mailbox by mail',
		saltDesc: 'Do not disclose key information easily'
	},
	password: {
		accountCenter: 'Account center',
		modifyLoginPassword: 'Change login password',
		oldPassword: 'Original login password',
		newPassword: 'New login password',
		again: 'Enter the password again',
		phoneCode: 'SMS verification code（SMS sent to',
		comfirm: 'Comfirm',

		oldpasswordMsg: 'Please enter the original login password',
		newPasswordMsg: 'Please enter a new login password',
		newPasswordAgain: 'Please enter your password again',
		differPassword: 'Password do not match.',
		saftyCode: 'Please enter the security verification code',
		passwordSuccess: 'Password changed successfully',
		codeOverTime: 'The verification code timed out',
		codeError: 'Verification error',
		oldPasswordError: 'Original password error',
		unknownError: 'Unknown error, login password change failed',
		tip: 'Warm Tip: To ensure your account security, please change your login password every 90 days',
		usTip: 'Tip: Change your password every 90 days for account security. Updates will sync across all PingPong services.',
		passwordMsg: 'Password strength: Weak, password contains at least uppercase letters, lowercase letters, numbers and not less than 8 digits',
		numberLetters: 'The password must be a combination of numbers and letters, without spaces, special characters',
		incorrectPwd: '密码不符合规则'

	},
	phone: {
		modifyBindPhone: 'Change the binding phone number',
		newPhone: 'new phone number',
		validateWay: 'Verify the way',
		phoneValidate: 'Cell phone verification',
		emailValidate: 'E-mail verification',
		oldPhoneCode: 'Original mobile phone verification code（SMS sent to',
		oldEmailCode: 'Mailbox Verification Code（The verification code will be sent',
		tip: 'Tip: Phone number updates will sync across all PingPong services.',
		newPhoneMsg: 'Please enter the new phone number',
		newPhoneCode: 'Please enter the new mobile phone verification code',
		emailCode: 'Please enter the email verification code',
		emailSuccess: 'Binding mailbox modified successfully',
		oldPhoneError: 'The original phone number was wrong',
		phoneRegister: 'The new mobile number has been registered',
		unknownError: 'Unknown error, failed to modify binding phone number',
		phoneSuccess: 'Binding Phone modified successfully'
	},
	email: {
		modifyBindEmail: 'Change binding mailbox',
		newEmail: 'New mail address',
		newEmailCode: 'New mailbox verification code',
		phoneCode: 'Mobile phone verification code（SMS sent to',
		newEmailMsg: 'Please enter a new email address',
		emailCode: 'Please enter the new email verification code',
		phoneCodeMsg: 'Please enter your mobile verification code',
		emailRegister: 'The new mailbox has been registered',
		unknowmError: 'Unknown error, failed binding mailbox modification',
		tip: 'Tip: Email updates will sync across all PingPong services.'

	},
	salt: {
		saltSetting: 'Key Setting',
		storeName: 'Website',
		omniStoreName: 'Store/Website',
		export: 'Export Key',
		accId: 'Acc ID',
		omniAccId: 'Store/Website ID',
		search: 'Search',
		reset: 'Reset',
		type: 'Type',
		apiStatus: 'API Status',
		updateTime: 'Update time',
		operation: 'Operation',
		saltDetail: 'Key Detail',
		salt: 'Key',
		copy: 'copy',
		freshenSalt: 'Refresh Key',
		freshenSaltTip: 'Note: Once the key is reset and the merchant system requests, you need to use the new key to complete the interaction with the system. Please operate with caution.',
		freshenSuccess: 'The key refresh successfully',
		latestSalt: 'Latest Key',
		timeOut: 'Verification Timeout',
		codeError: 'Verification error',
		unknownError: 'Unknown error',
		cancel: 'Cancel',
		normal: 'NORMAL',
		abnormal: 'UNBOUND'
	},
	tradeType: 'Trade type',
	tradeTypeOptions: {
		Service: 'Service',
		Goods: 'Goods',
		Digital: 'Digital Goods/Service',
		ServiceGoods: 'Service/Goods'
	},
	identityVerificationApproved: 'Verified'
}

export default en
